/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import BloodBankInventory from './blood-bank-inventory';
import BloodBankInventoryDetail from './blood-bank-inventory-detail';
import BloodBankInventoryUpdate from './blood-bank-inventory-update';
import BloodBankInventoryDeleteDialog from './blood-bank-inventory-delete-dialog';

const BloodBankInventoryRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<BloodBankInventory />} />
    <Route path="new" element={<BloodBankInventoryUpdate />} />
    <Route path=":id">
      <Route index element={<BloodBankInventoryDetail />} />
      <Route path="edit" element={<BloodBankInventoryUpdate />} />
      <Route path="delete" element={<BloodBankInventoryDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default BloodBankInventoryRoutes;
